var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMediaPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 132,
    viewBox: "0 0 128 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0L112 0C120.837 0 128 7.16344 128 16V116C128 124.837 120.837 132 112 132H16C7.16344 132 0 124.837 0 116L0 16ZM10 18C10 13.5817 13.5817 10 18 10L110 10C114.418 10 118 13.5817 118 18V98C118 102.418 114.418 106 110 106H18C13.5817 106 10 102.418 10 98L10 18ZM84.7688 73.1945L77.0277 83.243L56.8552 54.5613C55.2801 52.3218 51.9713 52.2911 50.3549 54.5009L24.6532 89.6385C22.7202 92.2811 24.6075 96 27.8817 96H75.3309H78.2964H100.059C103.344 96 105.229 92.259 103.273 89.6191L91.1518 73.2547C89.5714 71.1212 86.3891 71.0912 84.7688 73.1945ZM90.5 24C84.1487 24 79 29.1487 79 35.5C79 41.8513 84.1487 47 90.5 47C96.8513 47 102 41.8513 102 35.5C102 29.1487 96.8513 24 90.5 24Z",
    fill: "#F2F3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMediaPlaceholder);
export default __webpack_public_path__ + "static/media/ic-media-placeholder.5a455cf78750ca6f97a7e9604790bff8.svg";
export { ForwardRef as ReactComponent };